import React from 'react';
import { Brain, Activity } from 'lucide-react';
import { FadeIn } from './FadeIn';
export const NeuroscienceCallout: React.FC = () => {
  return <FadeIn data-id="element-163">
      <div className="my-16 bg-navy text-cream rounded-sm p-8 sm:p-10 shadow-xl relative overflow-hidden" data-id="element-164">
        {/* Decorative background element */}
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-amber/5 rounded-full blur-3xl pointer-events-none" data-id="element-165" />

        <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-166">
          <Activity className="w-6 h-6 text-amber" data-id="element-167" />
          <h3 className="text-sm font-sans font-bold tracking-widest uppercase text-amber" data-id="element-168">
            What Neuroscience Says
          </h3>
        </div>

        <div className="space-y-8 relative z-10" data-id="element-169">
          <div className="flex gap-4 items-start" data-id="element-170">
            <Brain className="w-6 h-6 text-cream/40 shrink-0 mt-1" data-id="element-171" />
            <div data-id="element-172">
              <p className="text-lg sm:text-xl font-serif italic leading-relaxed mb-3" data-id="element-173">
                "Pornography activates the same reward circuit as cocaine — with
                one difference: the supply never runs out."
              </p>
              <p className="text-sm font-sans text-cream/60" data-id="element-174">
                — Dr. Anna Lembke, Stanford University, Dopamine Nation (2021)
              </p>
            </div>
          </div>

          <div className="w-full h-px bg-cream/10" data-id="element-175" />

          <div className="flex gap-4 items-start" data-id="element-176">
            <Brain className="w-6 h-6 text-cream/40 shrink-0 mt-1" data-id="element-177" />
            <div data-id="element-178">
              <p className="text-lg sm:text-xl font-serif italic leading-relaxed mb-3" data-id="element-179">
                "Willpower uses the prefrontal cortex. But compulsive desire
                operates from the limbic system — a structure 100,000 years
                older."
              </p>
              <p className="text-sm font-sans text-cream/60" data-id="element-180">
                — Dr. Andrew Huberman, Huberman Lab Podcast, Ep. 39
              </p>
            </div>
          </div>
        </div>
      </div>
    </FadeIn>;
};